<template>
    <b-modal
        :id="id"
        :ref="ref"
        title="Add an appointment"
        :hideFooter="false"
        :scrollable="scrollable"
        centered
        lazy
        :size="size"
        :no-close-on-esc="false"
        @hidden="$emit('hidden')"
        @shown="$emit('shown')"
        tabindex="0"
        :no-enforce-focus="true"
        :dialog-class="dialogClass"
        :modal-class="modalClass"
    >
        <template slot="modal-header">
            <slot name="modal-header">
                <div class="card-header fixed py-0" style="width:100%">
                    <div class="row align-items-center">
                        <div class="col">
                            <h4 class="card-header-title">{{ title }}</h4>
                        </div>
                        <div class="col-auto" v-if="subtitle">
                            <h2 class="card-header-title text-muted">{{ subtitle }}</h2>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="close" aria-label="Close" @click="close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                </div>
            </slot>
        </template>

        <template slot="modal-footer">
            <slot name="modal-footer" :close="close" :confirmDelete="confirmDelete" :delayedSave="delayedSave">
                <div class="card-footer" style="display:block" v-if="actionButtons">
                    <div class="row">
                        <div v-if="$slots['modal-footer-actions']" class="col-auto">
                            <slot name="modal-footer-actions"></slot>
                        </div>
                        <div class="col">
                            <confirmable-button
								v-if="deleteAction"
								@confirm="confirmDelete()"
								buttonClass="btn btn-danger d-lg-inline-block"
								size="btn-normal"
							>
                                <i class="fe fe-trash"></i>
                            </confirmable-button>
                        </div>
                        <div class="col-auto">
							<button
								type="button"
								@click="print"
								aria-label="Print"
								class="btn btn-white mr-2"
								v-if="actionPrint"
							>
								<i class="fe fe-printer mr-md-1"></i>
								<span class="d-none d-md-inline-block">{{$t('Print')}}</span>
							</button>
                            <button
                                type="button"
                                @click="close"
                                aria-label="Close"
                                class="btn btn-white mr-2"
                            >{{$t('Cancel')}}</button>
                            <button
                                type="button"
                                :disabled="saveDisabled"
                                @click="delayedSave"
                                v-if="saveAction"
                                aria-label="Close"
                                class="btn btn-primary mr-2"
                            >
                                <div v-if="!saveDisabled">{{$t('Save')}}</div>
                                <div v-else class="spinner-border spinner-grow-sm">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </button>
                            <button
                                type="button"
                                @click="okAction"
                                v-if="okAction"
                                aria-label="Close"
                                class="btn btn-primary mr-2"
                            >{{('Ok')}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-footer" v-if="closeButton">
                    <button type="button" @click="close" aria-label="Close" class="btn btn-white">{{$t('Close')}}</button>
                </div>
            </slot>
        </template>
        <slot></slot>
    </b-modal>
</template>

<script>
import ConfirmableButton from '@/components/ConfirmableButton';
export default {
    components: {
        ConfirmableButton
    },
    props: [
		'okAction',
		'scrollable',
		'title',
		'subtitle',
		'id',
		'actionButtons',
		'closeButton',
		'prop',
		'saveAction',
		'size',
		'deleteAction',
		'model',
		'dialogClass',
		'modalClass',
		'actionPrint',
		'print'
	],
    data() {
        return {
            saveDisabled: false,
            timeout: null,
            ref: 'customModal'
        }
    },

    created() {

    },
    methods: {
        close() {
            this.$root.$emit('bv::hide::modal', this.id)
        },
        hideModal() {

        },
        confirmDelete() {
            this.deleteAction();
            this.close();
        },
        delayedSave() {
            this.saveDisabled = true
            this.timeout = setTimeout(() => {
                this.saveDisabled = false
            }, 2000);
            this.saveAction();

        }
    }
}
</script>


<style lang="scss">
header,
footer {
    border: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
}

footer {
    display: block !important;
}
.disabled {
    color: #ccc !important;
}
.card-footer {
    display: flex;
    align-items: flex-end;
    flex-direction: row-reverse;
}
.modal-full {
    max-width: 100%;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}

.modal-full .modal-content {
    height: 100%;
    border-radius: 0;
    overflow: auto;
}

.modal-full .close {
    font-size: 4rem;
    font-weight: normal;
}
@media only screen and (max-width: 576px) {
    .modal-full-screen-sm {
        margin: 0;
        max-height: 100% !important;
        .modal-content {
            border-radius: 0 !important;
        }
        .modal-body {
            padding: 0.5em !important;
            margin: auto;
            overflow-y: auto;
            overflow-x: hidden;
        }
    }
}
</style>
